# ROUTE CHUNKS ARE FETCHED WHEN THE ROUTE IS RENDERED, AND A LOST FETCH IS
# RETRIED. Card 6aad9e4dbb8767fbeba89f2c.
#
# WHAT WENT WRONG ON PRODUCTION. A customer on an Android System WebView
# (OnePlus 8 Pro, Chrome/90, an in-app browser) hit
#
#   ChunkLoadError: Loading chunk 7912 failed.
#   (error: assets.elephantlearning.com/clientDist/79123c7a1362dfa1.js)
#
# twice inside a minute, 0.1 min after boot, not logged in — chunk 7912 is the
# LOGIN FORM. The file is served correctly (200, 21228 bytes, CloudFront hit,
# CORS *, with that same Android user agent), and the main bundle from the same
# host loaded on the same device. So the script tag's error event fired on the
# DEVICE side: a weak mobile network, an old WebView, an in-app browser policy.
# webpack reported 'error:' rather than 'missing:' — a network failure, not a
# moved chunk. Fingerprint 29992042; every sighting is a failed login.
#
# TWO DEFECTS, BOTH IN THE OLD ONE-LINE HELPER.
#
#   standardComponent = (importPromise) -> lazy(() => importPromise)
#   Dashboard = standardComponent import('./Dashboard/dashboard.coffee')
#
#   1. The `import(...)` is EVALUATED AT MODULE LOAD, so all 24 route chunks of
#      /app (18 of /teacher, 13 of /org) were requested the instant the main
#      bundle evaluated — two dozen parallel requests on a phone before the
#      login form could render. One lost request among them killed the boot.
#   2. The promise is created once and captured, so a REJECTED import stays
#      rejected for the life of the page. React.lazy re-throws the same cached
#      rejection every time; Suspense cannot retry, nothing else does, and the
#      only way out is a manual full reload — which the error screen did not
#      offer and this customer did not find.
#
# WHAT THIS DOES INSTEAD. The call sites pass a FACTORY (`-> import('./x')`),
# so the chunk is fetched when the route is first rendered, and a fresh promise
# is made on every attempt:
#
#   - up to RETRIES further attempts with a short backoff, which is what a
#     one-off lost request on a flaky connection needs;
#   - if they all fail, ONE full reload, guarded per chunk through the same
#     reloadOnceFor the client-version reload uses — a page cannot reload twice
#     for the same chunk, whatever happens;
#   - if the guard is already spent, the rejection is handed to the error
#     boundary, which offers a Reload button.
#
# NOT A RETRY FOR EVERYTHING. `import()` cannot be cache-busted (there is no URL
# to add a query to), and bundles are never deleted from S3, so a chunk that is
# genuinely gone does not exist in this deploy model. Every failure here is a
# transport failure, which is exactly what a retry is for.
import { reloadOnceFor } from '../../../../schema/framework/shared/client_version.coffee'

RETRIES = 2
BACKOFF_MS = [400, 1200]

delay = (ms) -> new Promise (resolve) -> setTimeout resolve, ms

# The count is reported on the crash row's extra, so we can see whether the
# retries are rescuing anyone rather than guessing.
attemptsByChunk = {}

export getChunkAttempts = -> Object.assign {}, attemptsByChunk

# Load a route chunk, retrying transport failures, reloading once as a last
# resort. `name` identifies the chunk in the guard key and the logs.
export loadChunk = (factory, name, deps = {}) ->
  win = deps.window ? (if typeof window != 'undefined' then window else null)
  reload = deps.reloadOnceFor ? reloadOnceFor
  pause = deps.delay ? delay
  attempt = 0
  lastError = null
  loop
    try
      mod = await factory()
      attemptsByChunk[name] = attempt + 1
      return mod
    catch err
      lastError = err
      attempt += 1
      attemptsByChunk[name] = attempt
      break if attempt > RETRIES
      console.warn "[lazy route] chunk #{name} failed to load (attempt #{attempt}), retrying: #{err?.message or err}"
      await pause (BACKOFF_MS[attempt - 1] ? BACKOFF_MS[BACKOFF_MS.length - 1])
  console.error "[lazy route] chunk #{name} failed after #{attempt} attempts: #{lastError?.message or lastError}"
  # One reload for this chunk, ever. If it is already spent the boundary gets
  # the rejection and shows its Reload button — better an honest screen with a
  # way out than a tab that reloads for ever.
  if reload("chunk:#{name}", "chunk #{name} failed #{attempt} times", win)
    # The reload is in flight; never resolve, so React does not render a
    # boundary the page is about to replace.
    return await new Promise (->)
  lastError.chunkName = name if lastError?
  lastError.chunkAttempts = attempt if lastError?
  throw lastError
